import { Route, Routes } from 'react-router-dom';
import './App.css';
import AdminLayout from './admin/AdminLayout';
import AdminQuizs from './admin/AdminQuizs';
import Assignment from './admin/Assignment';
import AssignmentMarks from './admin/AssignmentMarks';
import Dashboard from './admin/Dashboard';
import Videos from './admin/Videos';
import AddVideo from './components/AddVideo';
import AdminRoute from './components/AdminRoute';
import PublicRoute from './components/PublicRoute';
import StudentRoute from './components/StudentRoute';
import AddAssigMark from './components/form/AddAssigMark';
import AddAssignment from './components/form/AddAssignment';
import AddQuiz from './components/form/AddQuiz';
import useAuthCheck from './hooks/useAuthCheck';
import Login from './pages/Login';
import Register from './pages/Register';
import CoursePlayer from './studentPortal/CoursePlayer';
import LeaderBoard from './studentPortal/LeaderBoard';
import Quizs from './studentPortal/Quizs';
import StudentLayout from './studentPortal/StudentLayout';

function App() {
  const authChecked = useAuthCheck();
  
  return (
   <>

{authChecked && 
<>

<Routes>
    <Route path='/' element={<PublicRoute> <Login/></PublicRoute> } />
    <Route path='/admin/login' element={<PublicRoute> <Login/></PublicRoute> } />
    <Route path='/register' element={<PublicRoute><Register/> </PublicRoute> } />

    <Route path='/student' element={<StudentRoute><StudentLayout/></StudentRoute> } > 
    <Route path='quiz/:videoId' element={<Quizs/>} />
    <Route path='leaderboard' element={<LeaderBoard/>} />
    <Route path='courseplayer' element={<CoursePlayer/>} />
    </Route>
    {/* Admin Route  */}
    <Route path='/admin' element={<AdminRoute><AdminLayout/> </AdminRoute>  } > 
    <Route path='dashboard' element={<Dashboard/> } />

    <Route path='videos' element={ <Videos/> } />
    <Route path='videos/add' element={ <AddVideo key={1}/> } />
    <Route path='videos/edit/:videoId' element={ <AddVideo key={2}/> } />
    
    <Route path='assignment' element={ <Assignment/> } />
    <Route path='assignment/add' element={ <AddAssignment key={1}/> } />
    <Route path='assignment/edit/:id' element={ <AddAssignment key={2}/> } />

    <Route path='assignment-marks' element={ <AssignmentMarks/> } />
    <Route path='assignment-marks/add' element={ <AddAssigMark key={1}/> } />
    <Route path='assignment-marks/edit/:id' element={ <AddAssigMark key={2}/> } />

    <Route path='quizs' element={ <AdminQuizs/> } />
    <Route path='quizs/add' element={ <AddQuiz key={1}/> } />
    <Route path='quizs/edit/:id' element={ <AddQuiz key={2}/> } />
    </Route>


   
   </Routes>
</>

}

   </>
  );
}

export default App;
